import { useState } from 'react'
import SelectField from './inputs/SelectField'
import { SupplierContactTypeLabels } from '@utils/constants'
import { SupplierDto, SupplierContactType } from '@services/dtos'
import { Alert, Button, Dialog, DialogContent, Typography } from '@mui/material'
import SupplierForm from './forms/SupplierForm'
import { useAppDispatch } from '@hooks/reduxHooks'
import { getProductOrders } from '@state/reducers/productOrderReducer'
import { UpTransition } from './animations'
import { Control } from 'react-hook-form'

interface Props {
  supplier: SupplierDto
  control: Control<any>
  className?: string
  multiple?: boolean
  contactTypes?: SupplierContactType[]
}

const SelectSupplierEmail = ({
  supplier,
  control,
  className,
  multiple = false,
  contactTypes,
}: Props) => {
  const dispatch = useAppDispatch()
  const [supplierFormIsOpen, setSupplierFormIsOpen] = useState<boolean>(false)

  const emailContacts = supplier.contacts.filter(({ email, type }) =>
    email && (!contactTypes || contactTypes.includes(type))
  )

  const handleCloseSupplierForm = () => {
    dispatch(getProductOrders())
    setSupplierFormIsOpen(false)
  }

  const baseLabel = multiple ? 'Emails fournisseur destinataires' : 'Email fournisseur destinataire'
  const label = contactTypes
    ? `${baseLabel} (${contactTypes.map(t => SupplierContactTypeLabels[t]).join(', ')})`
    : baseLabel

  return (
    <div className={className}>
      {emailContacts.length > 0 ? (
        <div className="mb-4">
          <SelectField
            data-cy="supplier-email-select"
            label={label}
            control={control}
            name={multiple ? 'supplierContactIds' : 'supplierContactId'}
            multiple={multiple}
            options={emailContacts.map(contact => ({
              label: `(${SupplierContactTypeLabels[contact.type]}) ${contact.email}`,
              value: contact.id,
            }))}
          />
          <Alert severity="info" className="mb-4 mt-2">
            <Typography className="!mb-1" variant="body2">
              {`Email manquant pour ${supplier.name} ?`}
            </Typography>
            <Button variant="outlined" size="small" onClick={() => setSupplierFormIsOpen(true)}>
              Modifier la fiche fournisseur
            </Button>
          </Alert>
        </div>
      ) : (
        <Alert severity="warning" className="mb-4">
          <Typography className="!mb-1" variant="body2">
            {`Aucun email configuré pour ${supplier.name}.`}
          </Typography>
          <Button variant="outlined" size="small" onClick={() => setSupplierFormIsOpen(true)}>
            Modifier la fiche fournisseur
          </Button>
        </Alert>
      )}

      <Dialog
        open={supplierFormIsOpen}
        onClose={handleCloseSupplierForm}
        maxWidth="md"
        TransitionComponent={UpTransition}
      >
        <DialogContent>
          <SupplierForm
            onClose={handleCloseSupplierForm}
            editingSupplier={supplier}
          />
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default SelectSupplierEmail
